module.exports = __webpack_public_path__ + "static/img/products discription_normal1.d824735d.jpg";